import { OnOffSwitchService } from "../Common/OnOffSwitchConfigurations/OnOffSwitchService";
export class Rog21ConfigService extends OnOffSwitchService {
    constructor() {
        super();
    }
    GetServiceName() {
        return Rog21ConfigService.ServiceName;
    }
}
Rog21ConfigService.ServiceName = "Rog21ConfigService";
//# sourceMappingURL=Rog21ConfigService.js.map